import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { fieldsSelector } from "../../redux/fieldsSlice";
import AdminInputs from "../admin-component/AdminInputs";
import SurveyForm from "../home/SurveyForm";
import Preview from "./Preview";

const InspectionViewModal = (props) => {
  const { fields } = useSelector(fieldsSelector);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      className="modalDrawer modalDrawerAdmin"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>View Inspection</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Preview />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn cta-primary-light" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InspectionViewModal;
